import { ApiSchema } from "@api-types";
import { LoadingPage } from "components/LoadingPage/LoadingPage";
import { hasPolicy$ } from "helpers/hasPolicy";
import React from "react";
import { useSubscription } from "rsm/useSubscription";
import { of } from "rxjs";
import { getFFService } from "services/ff.service";

const PageRoute: React.FC<{
  El: React.LazyExoticComponent<React.FC<{}>>;
  inPolicy?: ApiSchema.Policy;
  ff?: ApiSchema.FF;
}> = ({ El, inPolicy, ff }) => {
  useSubscription(
    inPolicy ? hasPolicy$(inPolicy) : of(true),
    (hasPolicy) => {
      if (inPolicy && !hasPolicy) {
        window.location.href = "/";
      }
    },
    [inPolicy],
  );
  useSubscription(
    ff ? getFFService().featureEnabled$(ff) : of(true),
    (hasFeature) => {
      if (!hasFeature) {
        window.location.href = "/";
      }
    },
    [ff],
  );
  return (
    <React.Suspense fallback={<LoadingPage />}>
      <El />
    </React.Suspense>
  );
};

export default PageRoute;
